import React, { useState, useEffect } from 'react';
import StaticDataTable from '../../../components/common/StaticDataTable';
import PageHeader from '../../../components/common/PageHeader';
import { CustomersLog } from '../../../api/endpoints/logs';
import { getUserInfo } from '../../../utils/token';
import HumanDateTime from '../../../components/common/HumanDateTime';


const columns = [
  { name: 'Log Type', selector: row => row.request_type, minWidth: '20px',left: true, sortable: true },
  { name: 'Time', selector:row => <HumanDateTime value={row.created_at} />, center: true, minWidth: '180px'},
  { name: 'Message Type', selector: row => row.message_type, center: true,  sortable: true },
  { name: 'Message', selector: row => row.message, center: true, wrap: true, minWidth: '250px' },
  { name: 'From Number', selector: row => row.mobile_from, center: true, minWidth: '150px', sortable: true },
  { name: 'To Number', selector: row => row.mobile_to, center: true, minWidth: '150px', sortable: true },
  { name: 'Credit Deduction', selector: row => row.credit_deduction, center: true,  sortable: true },
];

/*
const data = [
  { id: 1, name: 'Himanshu', email: 'himanshu@example.com' },
  { id: 2, name: 'Anya', email: 'anya@example.com' },
];
*/

const LogsList = () => {
  const [ data, setData ] = useState([]);
  const [ customerId, setCustomerId ] = useState("") ;
  
  useEffect(()=>{
      async function fetchData() {
        const userInfo = await getUserInfo();
        setCustomerId(userInfo.userId);
        const response  = await CustomersLog(userInfo.userId);
        console.log(response);
        if(response.status === 200){
          console.log(response.data.data);
          setData(response.data.data);
          //setListData(response.data.data);
        }else{
          // show alert something went wrong
        }
      }
      fetchData();  
    },[]);

  return (
    <>
      <PageHeader  title="Logs" breadcrumbs={[ {label: 'Administration'}, {label: 'Logs'}]}/>
      <div className="container mt-4">
        <StaticDataTable
          title="Logs Detail"
          columns={columns}
          data={data}
        />
      </div>
    </>
    
  );
}

export default LogsList